/**
 * @author       samuel@zumper.com (Samuel Shih)
 * @copyright    Copyright (c) 2019, Zumper
 * @description  trackInitialPageLoad.js
 */

import { getUser } from '@zcode-ui/web-zumper-global-state'
import { INITIAL_PAGE_LOAD, event } from '@zcode-ui/web-zumper-integrations'

import { getCurrentLocation } from '../../../inspectors/index'
import { selectFilters } from '../../filters/selectors/index'

export const trackInitialPageLoad =
  /**
   *
   * @param {{additionalProps?: object | undefined}} param0
   */
    ({ additionalProps }) =>
    (dispatch, getState) => {
      const state = getState()

      const user = getUser(state)
      const filters = selectFilters(state)
      const location = getCurrentLocation(state)

      dispatch(event({ name: INITIAL_PAGE_LOAD, props: additionalProps, user, filters, location }))
    }
